var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRomaniaLoto5From40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.1 43.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 14.205,
    cy: 30.2,
    r: 7.215,
    gradientTransform: "matrix(1 0 0 -1 0 44.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dadd84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#dadd84",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#dadd84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dadd84",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 6.9c4 0 7.2 3.2 7.2 7.2s-3.2 7.2-7.2 7.2S7 18.1 7 14.1s3.2-7.2 7.2-7.2z",
    fill: "url(#a)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 0.003,
    y1: 19.303,
    x2: 13.815,
    y2: 19.303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 14.3c-2.1 4.8-6.1 8.8-13.3 10-2.9-8.4 7.5-10.6 13.3-10z",
    fill: "url(#b)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 4.585,
    y1: 6.82,
    x2: 13.918,
    y2: 6.82
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 13.6C9.4 11.6 5.8 7.5 4.6.4c7.9-2.7 9.7 7.5 9.3 13.2z",
    fill: "url(#c)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 16.4,
    y1: 17.613,
    x2: 20.804,
    y2: 26.971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.3c4 1.7 7.3 5.4 8.3 11.7-7.1 2.4-8.7-6.6-8.3-11.7z",
    fill: "url(#d)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 14.445,
    y1: 9.804,
    x2: 25.239,
    y2: 9.804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 13.7c1.4-3.8 5.1-7.1 10.4-7.8 2.3 6.3-5.3 8.3-10.4 7.8z",
    fill: "url(#e)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 19.31,
    x2: 12.445,
    y2: 19.31
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M.7 24.3H.6c-2.7-7.9 6-10.3 11.9-10.1C7.1 15-.2 18.4.7 24.3z",
    fill: "url(#f)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 8.547,
    y1: 2.144,
    x2: 12.125,
    y2: 15.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4.6.6V.5C11.9-2 14 6.8 13.9 12.4 13.3 7.1 10.1-.1 4.6.6z",
    fill: "url(#g)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 15.871,
    y1: 14.735,
    x2: 18.899,
    y2: 23.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22.6 25.9v.1c-6.5 2.2-8.4-5.6-8.3-10.6.6 4.7 3.5 11.1 8.3 10.5z",
    fill: "url(#h)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 16.215,
    y1: 9.865,
    x2: 25.237,
    y2: 9.865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 13.8c5.5-1.2 8.6-4.1 8.6-7.8 2 5.5-3.8 7.7-8.6 7.8z",
    fill: "url(#i)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 4.898,
    y1: 26.109,
    x2: 13.293,
    y2: 15.237
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.5c-2.2 6.2-8 9.5-13.9 9.9 2.8 3.4 7.5 4 10.6.9 2.7-2.6 3.2-7.1 3.3-10.8z",
    fill: "url(#j)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 1.811,
    y1: 7.31,
    x2: 13.605,
    y2: 7.31
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 14.2C7.7 11.9 4.4 6.1 4.6.5 1.1 3.2.7 9 4.5 11.8c2.4 1.8 6.1 2.2 9.1 2.4z",
    fill: "url(#k)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 16.714,
    y1: 13.825,
    x2: 24.834,
    y2: 23.458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 13.9c5.2 2 8.2 7.2 8.1 12.2 3.2-2.5 3.3-7.5 0-10.1-2.1-1.7-5.4-2-8.1-2.1z",
    fill: "url(#l)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 14.034,
    y1: 8.556,
    x2: 24.835,
    y2: 8.556
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5c1.6-4.9 6.3-7.6 10.8-7.8-2.3-2.7-7.1-2.9-9.2.3-1.3 2.1-1.6 5-1.6 7.5z",
    fill: "url(#m)",
    style: {
      fillRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.1 35.9h-4.4v6h-4v-6H60.3v-3.3l11-17.4h5.4v17.6h4.4v3.1zm-8.4-3.1.2-14.1-8.3 14.1h8.1zM60 14.5h3.5L50.1 43.3h-3.5L60 14.5zm-13.6 3H33.3l-.1 7.6c3.2-1.4 8.3-.5 10 .6 2.2 1.2 3.7 3.9 3.7 7.3 0 5.4-4.3 9.4-10.2 9.4-3 0-5.9-1.2-7.4-2.3l.9-2.8c1.4.9 4 2.1 6.5 2.1 3.5 0 6.5-2.3 6.5-6 0-3.6-3.2-8.5-13.6-4.4l.3-14.6h16.5v3.1zm55.7 10.3c0 9.4-3.7 14.6-10.1 14.6-5.7 0-9.5-5-9.6-14.2 0-9.3 4.2-14.3 10.1-14.3 6.1-.1 9.6 5.1 9.6 13.9zm-15.4.4c0 6.9 2.2 10.8 5.6 10.8 3.8 0 5.6-4.3 5.6-11 0-6.5-1.7-10.8-5.6-10.8-3.3 0-5.6 3.8-5.6 11z",
    fill: "#f60025"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomaniaLoto5From40);
export default __webpack_public_path__ + "static/media/romania_loto_5_from_40.9c8df9fbfb5a5c9e0e8a8360f48fadb5.svg";
export { ForwardRef as ReactComponent };